import { z } from 'zod';
import { BaseApplicationDTOSchema } from "./applications.dto.js";
import { ApplicationSearchFiltersSchema, } from "./find-applications-by-facility.dto.js";
import { createPaginatedQuerySchema, } from "../../../../common/types/pagination.js";
// Request validation schema
export const ListApplicationsByCompanyRequestDTOSchema = z.object({
    params: z.object({
        companyId: BaseApplicationDTOSchema.shape.companyId,
    }),
    query: createPaginatedQuerySchema(ApplicationSearchFiltersSchema),
});
//# sourceMappingURL=list-applications-by-company.dto.js.map